export const CHART_DERMATOLOGY_TOGGLE_AREA = "CHART_DERMATOLOGY_TOGGLE_AREA";
